export default __webpack_public_path__ + "static/media/siesClosed.ed711be6.jpg";